import React from 'react';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { Product, patchProduct } from '../../../../model/product';
import { useChanges, Form } from '../../../../components/Form/Form';
import { isEmpty } from 'lodash';
import { TextField } from '../../../../components/Form/TextField/TextField';
import { t } from '../../../../locales/translate';
import { Datepicker } from '../../../../components/Form/Datepicker/Datepicker';
import { handleError } from '../../../../model/notification';
import { Stack } from '../../../../components/Stack/Stack';

interface Props {
  controller: ModalController<Product>;
}

export function MusicChartsForm({ controller }: Props): JSX.Element {
  const [changes, , model, trackChanges] = useChanges(controller.model);

  async function handleSubmit(): Promise<void> {
    try {
      await patchProduct(model.id, changes);
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleSubmit,
          canSubmit: form.valid && !isEmpty(changes),
        });
        return (
          <Stack>
            <TextField name="recordLabel" label={t.model.musicCharts.recordLabel}></TextField>
            <TextField name="recordDistributor" label={t.model.musicCharts.recordDistributor}></TextField>
            <Datepicker name="recordReleasedAt" label={t.model.musicCharts.recordReleasedAt} hourpicker></Datepicker>
            <TextField name="recordType" label={t.model.musicCharts.recordType}></TextField>
          </Stack>
        );
      }}
    </Form>
  );
}
